import { Card, Carousel } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import TopFiveTable from "./TopFiveTable";


function ServiceTopFive({ data }) {
    const [cpuData, setCpuData] = useState([{ station: "--", value: 0.0 }, { station: "--", value: 0.0 }, {
        station: "--",
        value: 0.0
    }, { station: "--", value: 0.0 }, { station: "--", value: 0.0 }]);
    const [heapData, setHeapData] = useState([{ station: "--", value: 0.0 }, { station: "--", value: 0.0 }, {
        station: "--",
        value: 0.0
    }, { station: "--", value: 0.0 }, { station: "--", value: 0.0 }]);
    const [kpiData, setKpiData] = useState([{ station: "--", value: 0.0, building: '--' }, { station: "--", value: 0.0, building: '--' }, {
        station: "--",
        value: 0.0, building: '--'
    }, { station: "--", value: 0.0, building: '--' }, { station: "--", value: 0.0, building: '--' }]);
    const [fileData, setFileData] = useState([{ station: "--", value: 0.0 }, { station: "--", value: 0.0 }, {
        station: "--",
        value: 0.0
    }, { station: "--", value: 0.0 }, { station: "--", value: 0.0 }]);
    const [deviceData, setDeviceData] = useState([{ station: "--", value: 0.0 }, {
        station: "--",
        value: 0.0
    }, { station: "--", value: 0.0 }, { station: "--", value: 0.0 }, { station: "--", value: 0.0 }])
    const [overrideData, setoverrideData] = useState([{ station: "--", value: 0.0 }, {
        station: "--",
        value: 0.0
    }, { station: "--", value: 0.0 }, { station: "--", value: 0.0 }, { station: "--", value: 0.0 }]);


    useEffect(() => {
        let newCpu = [];
        let newHeap = [];
        let newKpi = [];
        let newFile = [];
        let newDevice = [];
        let newOverride = []
        for (let i = 0; i < data.length; i++) {
            let eleC = { station: "--", value: 0.0, building: '--' };
            let eleH = { station: "--", value: 0.0, building: '--' };
            let eleK = { station: "--", value: 0.0, building: '--' };
            let eleF = { station: "--", value: 0.0, building: '--' };
            let eleD = { station: "--", value: 0.0, building: '--' };

            let eleO = { station: "--", value: 0.0, building: '--' };

            eleC.station = data[i].stationName;
            eleH.station = data[i].stationName;
            eleK.station = data[i].stationName;
            eleF.station = data[i].stationName;
            eleD.station = data[i].stationName;

            eleO.station = data[i].stationName;

            eleC.building = data[i].niagaraVersion;
            eleH.building = data[i].niagaraVersion;
            eleK.building = data[i].niagaraVersion;
            eleF.building = data[i].niagaraVersion;
            eleD.building = data[i].niagaraVersion;

            eleO.building = data[i].niagaraVersion;

            eleC.value = data[i].cpu;
            // console.log(ele);
            newCpu.push(eleC);
            eleH.value = data[i].heap;
            // console.log(ele);
            newHeap.push(eleH);
            eleK.value = data[i].kpi;
            // console.log(ele);
            newKpi.push(eleK);
            eleF.value = data[i].diskUsage / data[i].diskTotal * 100;
            // console.log(ele);
            newFile.push(eleF);
            eleD.value = data[i].downDeviceCount;
            // console.log(ele);
            newDevice.push(eleD);

            eleO.value = data[i].overrides;
            newOverride.push(eleO)
        }
        sortByProperty(newCpu, "value", true);
        sortByProperty(newHeap, "value", true);
        sortByProperty(newKpi, "value", false);
        sortByProperty(newFile, "value", true);
        sortByProperty(newDevice, "value", true);
        sortByProperty(newOverride, "value", true)
        if (data.length < 5) {
            for (let i = (data.length - 1); i < 5; i++) {
                let eleC = { station: "--", value: 0.0 };
                let eleH = { station: "--", value: 0.0 };
                let eleK = { station: "--", value: 0.0 };
                let eleF = { station: "--", value: 0.0 };
                let eleD = { station: "--", value: 0.0 };
                let eleO = { station: '--', value: 0.0 };
                newCpu.push(eleC);
                newHeap.push(eleH);
                newKpi.push(eleK);
                newFile.push(eleF);
                newDevice.push(eleD);
                newOverride.push(eleO)
            }


        }
        // console.log(newKpi);
        setCpuData(newCpu);
        setHeapData(newHeap);
        setKpiData(newKpi);
        setFileData(newFile);
        setDeviceData(newDevice);
        setoverrideData(newOverride)
        // console.log(deviceData);
        //  console.log(kpiData);
    }, [data]);

    function sortByProperty(array, prop, asc) {

        if (asc === true) {
            array = array.sort(function (a, b) {
                return b[prop] - a[prop];
            });
            return array;
        } else if (asc === false) {
            array = array.sort(function (a, b) {
                return a[prop] - b[prop];
            });
            return array;
        }
    }


    return (
        <Card bg="light" className="m-2" style={{ height: '24rem' }}>

            <Carousel variant="dark">
                <Carousel.Item>
                    <TopFiveTable
                        title="Top Five - Stations w/ Low Health KPIs"
                        data={kpiData}
                        keyName="Health KPI"
                        units="">
                    </TopFiveTable>
                </Carousel.Item>
                <Carousel.Item>
                    <TopFiveTable
                        title="Top Five - Stations w/ High Stale Data%"
                        data={heapData}
                        keyName="Heap"
                        units="%">
                    </TopFiveTable>
                </Carousel.Item>
                <Carousel.Item>
                    <TopFiveTable
                        title="Top Five - Stations w/ High Down Fault%"
                        data={deviceData}
                        units="%">
                    </TopFiveTable>
                </Carousel.Item>
                <Carousel.Item>
                    <TopFiveTable
                        title="Top Five - Stations w/ High Erratic Index"
                        data={overrideData}
                        units="">
                    </TopFiveTable>
                </Carousel.Item>
                {/* <Carousel.Item>
                    <TopFiveTable
                        title="Top Five - Stations w/ High Heap Usage"
                        data={heapData}
                        keyName="Heap"
                        units="%">
                    </TopFiveTable>
                </Carousel.Item>
                <Carousel.Item>
                    <TopFiveTable
                        title="Top Five - Stations w/ Low Health KPIs"
                        data={kpiData}
                        keyName="Health KPI"
                        units="">
                    </TopFiveTable>
                </Carousel.Item>
                <Carousel.Item>
                    <TopFiveTable
                        title="Top Five - Stations w/ Low File Allocation"
                        data={fileData}
                        keyName="File Allocation"
                        units="% Used">
                    </TopFiveTable>
                </Carousel.Item>
                <Carousel.Item>
                    <TopFiveTable
                        title="Top Five - Stations w/ Devices Down"
                        data={deviceData}
                        keyName="Online Devices"
                        units="%">
                    </TopFiveTable>
                </Carousel.Item> */}
            </Carousel>
        </Card>
    );
}

export default ServiceTopFive;
